import { ClaimMetadata } from '../redux/types';

export const sortClaimsByColumn = (
    claims: ClaimMetadata[],
    sortColumn: string,
    sortDirection: string
): ClaimMetadata[] => {
    return [...claims].sort((a, b) => {
        // since we often have empty strings for values like RCN,we move rows with empty values
        // to the end of the sort list regardless of sort direction
        const handleEmptyStrings = (a: string, b: string) => {
            if (!a && b) return 1; // empty string goes to end
            if (!b && a) return -1; // empty string goes to end
            return null;
        };

        const compareResult = (aValue: string, bValue: string) => {
            const safeA = aValue ?? '';
            const safeB = bValue ?? '';

            const emptyCheck = handleEmptyStrings(safeA, safeB);
            if (emptyCheck !== null) return emptyCheck;

            return sortDirection === 'ascending' ? safeA.localeCompare(safeB) : safeB.localeCompare(safeA);
        };
        const dateCompareDefaultDesc = b.submissionDate - a.submissionDate; // secondary sort is date descending

        switch (sortColumn) {
            case 'status':
                return compareResult(a.status, b.status) || dateCompareDefaultDesc;
            case 'createdByUser':
                return compareResult(a.createdByUser, b.createdByUser) || dateCompareDefaultDesc;
            case 'creationDate':
                return sortDirection === 'ascending'
                    ? a.submissionDate - b.submissionDate
                    : b.submissionDate - a.submissionDate;
            case 'resellerClaimNumber':
                return compareResult(a.resellerClaimNumber, b.resellerClaimNumber) || dateCompareDefaultDesc;
            default:
                return compareResult(a.fileName ?? '', b.fileName ?? '') || dateCompareDefaultDesc;
        }
    });
};
